import React from 'react';
import PropTypes from 'prop-types';
import {Card, CardContent} from "@mui/material";
import {styled} from "@mui/material/styles";
import BeatLoaderRegular from "components/loaders/BeatLoaderRegular";
import InfoTooltipIcon from "components/CustomTooltip/InfoTooltipIcon";
import {black500, green600, greyishBlue100, greyishBlue500, red600} from "assets/jss/main";

StatTile.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    value: PropTypes.number,
    hint: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    tooltip: PropTypes.node,
    loading: PropTypes.bool,
    alert: PropTypes.bool,
    previousValue: PropTypes.number
};

const Label = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '12px',
    fontWeight: 500,
    color: greyishBlue500,
    textTransform: 'uppercase',
    letterSpacing: '0.02em'
});

export function computeDeltaPercent(value, previousValue) {
    if (previousValue === null || previousValue === undefined) return null
    if (previousValue === 0) return value > 0 ? null : 0
    return Math.round(((value - previousValue) / previousValue) * 100)
}

function DeltaBadge({value, previousValue}) {
    const delta = computeDeltaPercent(value, previousValue)

    if (delta === null) {
        return <span style={{color: greyishBlue500}}>—</span>
    }

    const color = delta > 0 ? green600 : delta < 0 ? red600 : greyishBlue500
    const sign = delta > 0 ? '+' : ''

    return (
        <span style={{color, fontWeight: 600, whiteSpace: "nowrap"}}>
            {delta > 0 ? '▲' : delta < 0 ? '▼' : '='} {sign}{delta} %
        </span>
    )
}

function StatTile({label, value = 0, hint = null, tooltip = null, loading = false, alert = false, previousValue = null}) {
    const highlighted = alert && value > 0

    return (
        <Card sx={{
            boxShadow: 0,
            border: "1px solid " + greyishBlue100,
            borderRadius: "8px",
            minWidth: "150px",
            flex: 1
        }}>
            <CardContent sx={{padding: "12px 16px !important"}}>
                <Label>
                    {label}
                    {tooltip && (
                        <InfoTooltipIcon title={tooltip} multiline placement={"top"} enterTouchDelay={0} leaveTouchDelay={5000}/>
                    )}
                </Label>
                <div style={{fontSize: "28px", fontWeight: 600, lineHeight: "36px", marginTop: "4px", color: highlighted ? red600 : black500}}>
                    {loading ? <BeatLoaderRegular loading={true}/> : value.toLocaleString()}
                </div>
                {(hint || previousValue !== null) && !loading && (
                    <div style={{fontSize: "12px", color: greyishBlue500, display: "flex", gap: "6px", alignItems: "baseline", flexWrap: "wrap"}}>
                        {previousValue !== null && <DeltaBadge value={value} previousValue={previousValue}/>}
                        {hint}
                    </div>
                )}
            </CardContent>
        </Card>
    );
}

export default StatTile;
